module.exports = __webpack_public_path__ + "img/_logo.82b9c7a5.png";